import { render, staticRenderFns } from "./shipment-close-payments-page.vue?vue&type=template&id=a8b02866"
import script from "./shipment-close-payments-page.vue?vue&type=script&lang=js"
export * from "./shipment-close-payments-page.vue?vue&type=script&lang=js"
import style0 from "./shipment-close-payments-page.vue?vue&type=style&index=0&id=a8b02866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports